import React from "react";
import SEO from "../components/SEO";

const Cookie = () => {
  return (
    <>
      <SEO
        title='Cookie'
        description='Patch Designers For Hats'
        keywords='Patch Designers For Hats'
      />
      <div className="relative bg-gradient-to-br from-green-50 via-white to-green-100 min-h-screen">
        {/* Decorative Blobs */}
        <div className="absolute top-0 left-0 w-72 h-72 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#369a74]/20 rounded-full blur-3xl -z-10" />

        <div className="container mx-auto px-4 py-20 max-w-6xl">
          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-extrabold text-[#369a74]">
              Cookie Policy
            </h1>
            <p className="mt-4 text-gray-700 max-w-3xl mx-auto text-lg leading-relaxed">
              Learn how <span className="font-semibold">Personalised Patches for Hats</span> uses cookies to enhance your experience and optimize our website.
            </p>
          </div>

          {/* Content Card */}
          <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-gray-200 p-8 md:p-12 space-y-12">
            {[
              {
                title: "Introduction",
                content: (
                  <p>
                    At <span className="font-semibold">Personalised Patches for Hats</span>,
                    we use cookies to optimize website functionality, analyze site
                    performance, and provide a personalized experience. Some cookies
                    are essential and ensure the website functions correctly — these
                    cannot be disabled. Below, you can learn more about the cookies we
                    use and manage your preferences.
                  </p>
                ),
              },
              {
                title: "Strictly Necessary Cookies",
                content: (
                  <>
                    <p>
                      These cookies are essential for enabling you to browse our website
                      and use its features, such as accessing secure areas. The website
                      cannot function properly without them.
                    </p>
                    <ul className="list-disc pl-6 mt-3 space-y-2 text-gray-700">
                      <li>_tracking_consent – 1 year – First-party</li>
                      <li>secure_customer_sig – 1 year – First-party</li>
                      <li>cart_currency – Session – First-party</li>
                      <li>keep_alive – 30 minutes – First-party</li>
                      <li>locale_bar_accepted – Session – First-party</li>
                      <li>cart_sig – 1 month – First-party</li>
                      <li>cart – 1 month – First-party</li>
                      <li>localization – 1 year – First-party</li>
                    </ul>
                  </>
                ),
              },
              {
                title: "Performance Cookies",
                content: (
                  <>
                    <p>
                      These cookies help us understand how visitors interact with our site
                      by collecting and reporting information anonymously.
                    </p>
                    <ul className="list-disc pl-6 mt-3 space-y-2 text-gray-700">
                      <li>_orig_referrer – Session – First-party</li>
                      <li>_shopify_y – 1 year – First-party</li>
                      <li>_landing_page – Session – First-party</li>
                      <li>_shopify_s – 30 minutes – First-party</li>
                      <li>_shopify_sa_t – 30 minutes – First-party</li>
                      <li>_shopify_sa_p – 30 minutes – First-party</li>
                      <li>_ga – 1 year – First-party</li>
                      <li>_ga_* – 1 year – First-party</li>
                      <li>_sp_ses.* – 30 minutes – First-party</li>
                      <li>_sp_id.* – 1 year – First-party</li>
                      <li>bugsnag-anonymous-id – 1 year – Third-party</li>
                    </ul>
                  </>
                ),
              },
              {
                title: "Targeting Cookies",
                content: (
                  <>
                    <p>
                      These cookies may be set by advertising partners to build a profile
                      of your interests and show relevant ads. They do not store direct
                      personal information.
                    </p>
                    <ul className="list-disc pl-6 mt-3 space-y-2 text-gray-700">
                      <li>_gcl_au – 3 months – First-party</li>
                      <li>_uetsid – 1 day – First-party</li>
                      <li>_uetvid – 1 year – First-party</li>
                      <li>_fbp – 3 months – First-party</li>
                      <li>lastExternalReferrer – 1 year – First-party (Local Storage)</li>
                      <li>lastExternalReferrerTime – 1 year – First-party (Local Storage)</li>
                    </ul>
                  </>
                ),
              },
              {
                title: "Unclassified Cookies",
                content: (
                  <p>
                    These are cookies we are still classifying with the help of their
                    providers. If you’d like more information about these cookies, please
                    contact us.
                  </p>
                ),
              },
              {
                title: "Manage Preferences",
                content: (
                  <p>
                    You can control your cookie preferences at any time by adjusting
                    your browser settings or clicking “Manage Preferences” in the
                    cookie banner.
                  </p>
                ),
              },
            ].map((section, idx) => (
              <section
                key={idx}
                className="relative pl-6 group hover:bg-[#369a74]/10 transition-all duration-300 rounded-xl p-4"
              >
                <div className="absolute left-0 top-2 h-full w-1 rounded-full bg-gradient-to-b from-[#369a74] to-[#32c499] group-hover:scale-110 transition-transform" />
                <h2 className="text-2xl font-bold text-[#369a74] mb-4">
                  {section.title}
                </h2>
                <div className="text-gray-700 leading-relaxed text-base">
                  {section.content}
                </div>
              </section>
            ))}

            {/* Contact */}
            <section className="border-t pt-8 text-center">
              <h2 className="text-2xl font-bold text-[#369a74] mb-4">
                Contact Us
              </h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about our use of cookies or your data,
                please reach out:
              </p>
              <div className="mt-4 text-gray-700">
                <p className="font-semibold text-[#369a74]">Personalised Patches for Hats</p>
                <p>Email: support@personalisedpatchesforhats.com</p>
                <p>Phone: (703) 666-8193</p>
              </div>
            </section>

            {/* Footer */}
            <p className="text-sm text-gray-500 text-center pt-6 border-t">
              Last updated: 07/08/2025
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cookie;
